// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import imageSinge from '../../../../assets/img/grids/gridSinge.png';
import imageTel from '../../../../assets/img/grids/telVictoire.png';
import { Target } from '../../../../client';
import Formatter from '../../../../i18n/formatter';
import { __, getCurrency } from '../../../../i18n/l10n';
import { BetslipDisplayStatuses } from '../../../../types/betslip';
import { MatchStatuses } from '../../../../types/match';
import Selection from '../../states/selection';
import { GridMatchLengths, GridTypes } from '../../types';
import { GridsActionTypes } from '../../types/actions';
import StakeSelector from '../basket/GridsBasketStakeSelector';
import TogglePrivate from '../basket/GridsTogglePrivate';
import TypeTabs from '../basket/GridsTypeTabs';
import StakeLabel from '../basket/StakeLabel';
import EmptyView, { P, Bold } from '../EmptyView';
import GridLine from '../grid/GridsGridLine';
import HistoryGridHeaderStatus from '../history/GridsHistoryGridHeaderStatus';
import GridsSystemButtons from '../pool/GridsSystemActions';
import GridsSystemButton from '../pool/GridsSystemButton';
import PoolTitle from '../pool/PoolTitle';
import GridsAuthor from '../public/GridsAuthor';

import Emoji from './Emoji';
import TutoGrid from './TutoGrid';
import { tutoMatchs, tutoChecks, tutoSelection, tutoResultSelection, tutoSystemSelection } from './tutoMocks';

const StyledView = styled(EmptyView)`
  ${!Target.__MOBILE__
    ? css`
        margin-top: 3em;
      `
    : undefined}
`;

const Text = styled(P)`
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  color: ${({ theme }) => theme.grids.colors.lightgrey};
`;

const CustomBold = styled(Bold)`
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
`;

const TextUpper = styled(Bold)`
  text-transform: uppercase;
`;

const Svg = styled.svg`
  width: 50%;
  margin: 1em auto;

  polyline,
  line {
    fill: none;
    stroke: #fff;
  }
`;

const SvgLine = styled(Svg)`
  position: relative;
  z-index: 1;
  width: 100%;
  margin: -10px 0 1em;
  line {
    fill: none;
    stroke-width: 0.2;
  }
  text {
    fill: #fff;
    stroke: none;
    font-size: 0.28em;
    text-anchor: middle;
  }
  text:nth-of-type(4) {
    text-anchor: end;
  }
`;

const WhiteBloc = styled.div`
  border-radius: 0.6em;
  margin: 1em 0;
  padding: 0.5em;
  box-shadow: 0 2px 10px 0 rgba(34, 36, 38, 0.12);
  background: #fff;
  ${!Target.__MOBILE__ && `width: 80%; margin: 0 auto; font-size: 0.9em;`}
`;

const BlackBloc = styled(WhiteBloc)`
  background: ${({ theme }) => theme.grids.colors.black};
`;

const StyledPoolTitle = styled(PoolTitle)`
  color: ${({ theme }) => theme.grids.colors.black};
  .grid-picto {
    stroke: ${({ theme }) => theme.grids.colors.black};
  }
`;

const BlocGrid = styled(TutoGrid)`
  ${({ theme }) => theme.grids.desktopBloc}
  ${!Target.__MOBILE__
    ? css`
        width: 80%;
        margin: 0 auto;
      `
    : undefined}
`;

const StyledGridLine = styled(GridLine)`
  background: ${({ theme }) => theme.grids.colors.darkgrey4};
`;

const StyledGridsSystemButton = styled(GridsSystemButton)`
  display: flex;
  justify-content: center;
`;

const StyledStakeSelector = styled(StakeSelector)`
  padding: 0.2em 0.2em 0.2em 0.6em;
  margin-bottom: 1em;
  input {
    background-color: #fff;
    color: ${({ theme }) => theme.grids.colors.black};
  }
`;

const emptyFunc = () => {};

const Step1 = () => (
  <StyledView isDisabledFit imgPath={imageTel}>
    <TextUpper>{__('Welcome to the grid tutorial')}</TextUpper>
    <CustomBold>{__("We'll explain everything step by step!")}</CustomBold>
  </StyledView>
);

const Step2 = () => (
  <StyledView isDisabledFit>
    <BlocGrid matches={tutoMatchs} selection={tutoSelection} onCheckBox={emptyFunc} hideInfo />
    <Text>{__('Choose your format (7 or 12 matches) and validate your own grid.')}</Text>
  </StyledView>
);

const Step3 = () => (
  <StyledView isDisabledFit>
    <CustomBold>{__("Didn't understand everything on the previous screen?")}</CustomBold>
    <StyledGridLine
      matchIndex={0}
      competitor1={tutoMatchs[0].competitor1Name}
      competitor2={tutoMatchs[0].competitor2Name}
      checks={tutoChecks}
      isTuto
    />
    <SvgLine viewBox="0 0 100 40" width={100}>
      <line x1="20" y1="0" x2="20" y2="18" />
      <line x1="50" y1="0" x2="50" y2="18" />
      <line x1="74" y1="0" x2="74" y2="18" />
      <line x1="94" y1="0" x2="94" y2="32" />
      <text x="20" y="25">
        {__('Team 1')}
      </text>
      <text x="50" y="25">
        {__('Draw')}
      </text>
      <text x="74" y="25">
        {__('Team 2')}
      </text>
      <text x="94" y="40">
        {__('Match details and odds')}
      </text>
    </SvgLine>
    <Text>{__("It's simple! Select a result of your choice (team 1 or team 2 or draw) for each match.")}</Text>
    <Text>
      {__('You can also make doubles or triples to increase your chances of winning')}{' '}
      <Emoji label="sunglasses" symbol="😎" />
    </Text>
  </StyledView>
);

const Step4 = () => (
  <StyledView isDisabledFit>
    <WhiteBloc>
      <StyledPoolTitle poolNumber={1700} withPicto />
      <TypeTabs gridType={GridTypes.PERSONAL} />
      <TutoGrid matches={tutoMatchs} selection={tutoSelection} isBasket />
      <StakeLabel stake={Selection.getAmount(tutoSelection)} label={__('Grid price')} />
    </WhiteBloc>
    <Text>
      {__('Finance your entire grid or share the jackpot by playing as a team.')}{' '}
      <Emoji label="call me hand" symbol="🤙" />
    </Text>
  </StyledView>
);

const Step5 = () => {
  const stakeLabel = __('My wager');
  const stakeRange = __('(1 to %1$s)', Formatter.formatNumber(24, getCurrency(), false, true));
  return (
    <StyledView isDisabledFit>
      <WhiteBloc>
        <TogglePrivate isPrivate={false} togglePrivate={emptyFunc} isDark />
        <StyledStakeSelector
          stakeLabel={`${stakeLabel} ${stakeRange}`}
          stake={10}
          setStake={emptyFunc}
          maxStake={24}
          isKeyboarDisabled
        />
      </WhiteBloc>
      <Text>{__('Choose the amount of your stake on this grid as a team.')}</Text>
      <Text>
        {__('Do you want to keep a low profile and only share your grid with your friends? Opt for the private grid.')}{' '}
        <Emoji label="call me hand" symbol="🤙" />
      </Text>
    </StyledView>
  );
};

const Step6 = () => (
  <StyledView isDisabledFit>
    <StyledGridsSystemButton toggleSystem={() => ({ type: GridsActionTypes.TOGGLE_SYSTEM_MODE })} isSystem />
    <Text>
      {__('The system grid is an expert mode. It allows you to create complex grids with some basic matches.')}{' '}
      <Emoji label="sunglasses" symbol="😎" />
    </Text>
    <GridsSystemButtons
      isSystem
      copySystemGrid={(index) => ({
        type: GridsActionTypes.COPY_SYSTEM_GRID,
        payload: { index },
      })}
      removeSystemGrid={(index) => ({
        type: GridsActionTypes.REMOVE_SYSTEM_GRID,
        payload: { index },
      })}
    />
    <Text>
      {__('Additional buttons allow you to make variations of an existing grid.')} <Emoji label="angel" symbol="😇" />
    </Text>
  </StyledView>
);

// __('Check out the public grids as well as information about the authors of these grids and find the one that suits you best.')}

const Step7 = () => (
  <StyledView isDisabledFit>
    <BlackBloc>
      <GridsAuthor
        nickname="Grid"
        avatarPath={imageSinge}
        winnings={20207}
        gridAmount={6}
        fundingAmount={5}
        contributorsCount={3}
        gridDate={1581775200}
        gridLength={GridMatchLengths.SEVEN}
      />
      <TutoGrid matches={tutoMatchs} selection={tutoSystemSelection} hideInfo isSystemCompact />
    </BlackBloc>
    <Text>{__('Lacking inspiration? You can also take part in a public grid.')}</Text>
    <Text>
      {/* eslint-disable-next-line */}
      {__(
        'Check out the public grids as well as information about the authors of these grids and find the one that suits you best.',
      )}
    </Text>
  </StyledView>
);

const Step8 = () => (
  <StyledView isDisabledFit>
    <BlackBloc>
      <HistoryGridHeaderStatus
        betAmount={4}
        winningsAmount={452}
        status={BetslipDisplayStatuses.WINNING}
        statusLabel={__('Won')}
        gridAmount={1}
      />
      <TutoGrid
        matches={tutoMatchs.map((m) => ({ ...m, status: MatchStatuses.ENDED }))}
        selection={tutoSelection}
        resultSelection={tutoResultSelection}
      />
    </BlackBloc>
    <Text>
      <Emoji label="boom" symbol="💣" /> {__('BOOM, easy game!')}
    </Text>
    <Text>{__('Follow the live results and stats of your grids.')}</Text>
    <Text>{__("Find out how much you've pocketed as soon as the last game of your grid ends.")}</Text>
  </StyledView>
);

const Step9 = () => (
  <StyledView isDisabledFit imgPath={imageSinge}>
    <CustomBold>{__('Your turn to play!')}</CustomBold>
    <CustomBold>{__('And remember,')}</CustomBold>
    <CustomBold>{__("It's not the grids that matter, it's what you do with them!")}</CustomBold>
  </StyledView>
);

const Steps = [Step1, Step2, Step3, Step4, Step5, Step6, Step7, Step8, Step9];

export const TUTO_NB_STEPS = Steps.length;

export default Steps;
